<template>
    <div v-if="isShowDirectMessageForm" style="position: fixed; overflow-y: scroll; left: 0; top: 0; width: 100%; height: 100%; backdrop-filter: blur(5px); background: linear-gradient(180deg, rgba(33, 15, 3, 0.9) 50%, #652B04 100%); z-index: 100;">
        <div style="margin-top: 98px; color: #fff; text-align: center; position: relative;">
            <div style="font-weight: 700; font-size: 24px; line-height: 24px;">지금 바로 답변하기</div>
            <div style="font-size: 14px; font-weight: 500; line-height: 24px;">게시물의 댓글로 전달됩니다</div>
            <div @click="closeDirectMessageForm" style="position: absolute; top: 0; right: 0; padding-right: 12px;">
                <img style="width: 40px;" :src="require('@/assets/img/recent_x_btn.png')" alt="">
            </div>
        </div>
        <div style="padding: 0 12px; margin-top: 20px;">
            <swiper @slideChange="slideChange" ref="mySwiper" style="border-radius: 12px; height: 234px; overflow: hidden;" :options="swiperOption" role="tablist">
                <swiper-slide v-for="each, i in topicData" :key="i + 'test'" style="width: 100%; height: 100%; overflow: hidden; display: flex; flex-direction: column; border-radius: 12px; position: relative; padding: 12px;" role="tab">
                    <div style="flex: 1;" @click="showFeedDetail(each)">
                        <div style="background: #210F0399; position: absolute; width: 100%; height: 100%; top: 0; left: 0; z-index: -1;"></div>
                        <img v-if="!each.thumbnail_path1" style="position: absolute; width: 100%; height: 100%; top: 0; left: 0; z-index: -2; object-fit: fill;" :src="require('@/assets/img/test_back.png')" alt="">
                        <img v-else style="position: absolute; width: 100%; height: 100%; top: 0; left: 0; z-index: -2; object-fit: cover;" :src="$resourcePath + each.thumbnail_path1" alt="">
                        <div style="display: flex; align-items: center; gap: 4px; font-weight: 500; font-size: 12px; line-height: 16px; color: #BBBBBB;">
                            대답을 기다리는 피드
                            <span style="display: inline-block; width: 2px; height: 2px; border-radius: 50%; background: #BBBBBB;"></span>
                            <span style="color: #fff;">{{ each.reply_number | comma }}명 </span> 참여
                        </div>
                        <div style="display: flex; gap: 8px; align-items: center; margin-bottom: 8px; margin-top: 20px;">
                            <ProfileImage :imagePath="each.image_path" style="width: 40px;"></ProfileImage>
                            <div>
                                <div style="color: #fff; font-weight: 700; font-size: 12px; line-height: 24px;">{{ each.nic_name }} <span style="font-size: 10px; color: var(--color-main);">{{ each.position }}</span></div>
                                <div style="display: flex; align-items: center; color: #bbbbbb; font-weight: 500; font-size: 12px; line-height: 16px; gap: 4px;">{{ each.place_name }}
                                    <span style="display: inline-block; width: 2px; height: 2px; border-radius: 50%; background: #BBBBBB;"></span>
                                    {{ each.insert_date | agoDateStr }}
                                </div>
                            </div>
                        </div>
                        <div style="font-size: 20px; flex: 1; line-height: 32px; font-weight: 700; color: #fff; padding-bottom: 10px; overflow-y: scroll;">{{ $Util.removeYoutubeLink(each.contents) }}</div>
                    </div>
                </swiper-slide>
                <div class="swiper-pagination paging_text" slot="pagination" style="font-size:12px; padding-right: 20px; display:inline-block;"></div>
            </swiper>
        </div>
        <div style="margin-top: 78px; padding: 0 12px;">
            <div style="font-size: 14px; font-weight: 700; line-height: 24px; color: #fff;">답변 쓰기</div>
            <div style="margin-top: 8px;">
                <textarea v-model="messageContents" style="color:white; line-height: 24px;width: 100%; border: none; outline: none; resize: none; border-radius: 12px; background-color: rgba(33, 15, 3, 0.7); padding: 12px; height: 240px;" name="" id="" :placeholder="placeholder"></textarea>
            </div>
            <div style="display: flex; margin: 0 auto; width: 118px; height: 56px; margin-left: auto; margin-top: 12px; margin-bottom: 30px; border-radius: 45px; background-color: #fff; justify-content: center; gap: 4px; align-items: center;">
                <div @click="sendMessage" style="font-weight: 700; font-size: 14px;">답변하기</div>
                <div>
                    <img style="width: 12px;" :src="require('@/assets/img/message.png')" alt="">
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { swiper, swiperSlide } from 'vue-awesome-swiper'
import ProfileImage from '@/components/common/ProfileImage'
import ResponseCode from '@/ResponseCode'
import { FORM_MODE, SOCCER_HOW_TYPE, MAIN_TYPE } from "../../Constants";

export default {
    name: 'SendDirectMessage',
    components: { swiper, swiperSlide, ProfileImage },
    props: {
        closeDirectMessageForm: {
            type: Function,
            default: () => { }
        },
        startIndex: {
            type: Number,
            default: 0
        },
        isShowDirectMessageForm: {
            type: Boolean,
            default: false
        },
        topicData: {
            type: Array,
            default: () => { }
        },
        completeAction: {
            type: Function,
            default: () => { }
        }
    },
    data() {
        return {
            swiperOption: {
                // slidesPerView: 'auto',
                spaceBetween: 0, // swiper-slide 사이의 간격 지정
                slidesOffsetBefore: 0, // slidesOffsetBefore는 첫번째 슬라이드의 시작점에 대한 변경할 때 사용
                slidesOffsetAfter: 0, // slidesOffsetAfter는 마지막 슬라이드 시작점 + 마지막 슬라이드 너비에 해당하는 위치의 변경이 필요할 때 사용
                freeMode: false, // freeMode를 사용시 스크롤하는 느낌으로 구현 가능
                centerInsufficientSlides: true, // 컨텐츠의 수량에 따라 중앙정렬 여부를 결정함
                loop: false,
                pagination: {
                    el: '.swiper-pagination',
                    type: 'bullets'
                },
                curIndex: 0,
                initialSlide: 0
            },
            MAIN_TYPE: MAIN_TYPE,
            selectedPost: {},
            messageContents: '',
            placeholder: '직접 코칭해줄 수 있다고 어필할 수도 있습니다!\n 코칭소개나 직접적인 노하우 등 자유롭게 입력하세요\n\n예시) 안녕하세요 김민재 코치입니다. 저는 공미로 주로 활동했고 탈압박을 할때 팬텀 드리블을 자주 사용했는데요...\n또는\n 무게중심을 낮추는 습관이 들어야 합니다. 한번 저희 팀에서 입단 테스트를 보시면 좋으실 것 같아요...'
        }
    },
    methods: {
        showFeedDetail(detail) {
            this.$GlobalStore.addModal('TrainingRequestDetail', { main_type: MAIN_TYPE.SOCCER_LEARN, isModalBackTransparent: true, isExpert: true, soccerhowIdx: detail.idx })
        },
        slideChange() {
            const swiper = this.$refs.mySwiper.swiper; // Swiper 인스턴스 가져오기
            const currentIndex = swiper.activeIndex;   // 현재 슬라이드의 인덱스
            this.selectedPost = this.topicData[currentIndex]
        },
        async sendMessage() {
            if (this.messageContents.length < 5) {
                alert('5글자 이상 작성해주세요')
                return
            }
            const parameters = {};
            parameters.type = SOCCER_HOW_TYPE.REPLY;
            parameters.title = '';
            parameters.mode = FORM_MODE.INSERT;
            parameters.contents = this.messageContents;
            parameters.parentIdx = this.selectedPost.idx;

            const res = await this.$Axios.post('/api/soccerhow/save', parameters);
            if (res.data.code === ResponseCode.SUCCESS) {
                this.completeAction();
                this.closeDirectMessageForm();
                this.$GlobalStore.showToast('답변이 등록되었습니다.');
            } else if (res.data.code === ResponseCode.FAIL) {
                this.$GlobalStore.showAlert(res.data.msg);
            }
            // const formData = new FormData()
            //
            // formData.append('refer_idx', this.selectedPost.idx)
            // formData.append('contents', this.messageContents)
            //
            // const res = await this.$Axios.post('/api/direct_message/send', formData)
            //
            // if (res.data.code === ResponseCode.SUCCESS) {
            //     this.$GlobalStore.showAlert('답변이 전달되었습니다.')
            //     this.closeDirectMessageForm()
            // }
        }
    },
    watch: {
        isShowDirectMessageForm(newVal) {
            if (newVal) {
                this.swiperOption.initialSlide = this.startIndex
                this.selectedPost = this.topicData[this.startIndex]
            }
            this.messageContents = '';
        }
    },
    created() {
        this.sendMessage = this.$Once(this.sendMessage)
    }
}
</script>

<style scoped>
.swiper-pagination>>>.swiper-pagination-bullet-active {
    background: #fff
}

.swiper-pagination>>>.swiper-pagination-bullet {
    width: 6px;
    height: 6px;
}

textarea::placeholder {
    font-size: 15px;
}
</style>